import * as React from 'react';
import {
  NotificationModal,
  useOpenNotificationModal
} from 'catering/components/Modals';
import { PrimaryCta } from 'components/Buttons';

import { fulfillmentOptionsDisplayText } from 'constants/fulfillmentOptions';
export function MenuHoursExpiredNotificationModal() {
  // TODO: hard-coding this here for now. we'll eventually grab data from the cart
  const cart = {
    fulfillmentMethod: 'delivery'
  };
  const { fulfillmentMethod } = cart;

  // TODO: missing implementation
  const handlePrimaryCtaClick = () => {
    window.alert('Set A New Time');
  };

  const fulfillmentMethodDisplayText =
    fulfillmentOptionsDisplayText[fulfillmentMethod];

  return (
    <NotificationModal
      title="Oops! This menu has changed"
      text={`Please set a new time for your ${fulfillmentMethodDisplayText} order. Be aware that item
        availability may have changed.`}
    >
      <PrimaryCta
        label="Set A New Time"
        handleClick={handlePrimaryCtaClick}
        fullWidth
      />
    </NotificationModal>
  );
}

export function useOpenMenuHoursExpiredNotificationModal() {
  return useOpenNotificationModal(<MenuHoursExpiredNotificationModal />);
}
